import axios from "axios";
import { API_BASE_URL } from "../config/env";

export const client = axios.create({ baseURL: `${API_BASE_URL}` });
export const ibge = axios.create({ baseURL: 'https://servicodados.ibge.gov.br/api/v1' });
